import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import userConfig, { userConfigSaga } from './userConfig';

const staticsModule = combineReducers({
    userConfig,
});

export function* staticsModuleSaga() {
  yield all([
    userConfigSaga(),
  ]);
}

export default staticsModule;
